import React from 'react';
import { MAX_VOLUME, MIN_VOLUME, normalizeVolume } from '../../utils/overlay-volume';

interface Props {
  id: string;
  label: string;
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
  /** Dòng giải thích nhỏ dưới thanh trượt. */
  hint?: React.ReactNode;
  /** Nút phụ cạnh nhãn, ví dụ "Nghe thử". */
  action?: React.ReactNode;
}

/** Thanh trượt âm lượng 0–100 có hiện số phần trăm, dùng chung cho Cài đặt Donate và bảng điều khiển phát nhạc. */
const VolumeSlider: React.FC<Props> = ({ id, label, value, onChange, disabled, hint, action }) => (
  <div className="flex flex-col gap-1">
    <div className="flex items-center justify-between gap-2">
      <label htmlFor={id} className="text-sm font-medium ui-heading">
        {label}
      </label>
      {action}
    </div>
    <div className="flex items-center gap-3">
      <input
        id={id}
        type="range"
        min={MIN_VOLUME}
        max={MAX_VOLUME}
        step={1}
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(normalizeVolume(e.target.value, value))}
        className="h-2 min-w-0 flex-1 cursor-pointer accent-blue-600 disabled:cursor-not-allowed disabled:opacity-60"
      />
      <span className="w-12 shrink-0 text-right text-sm font-semibold tabular-nums ui-text" aria-hidden="true">
        {value}%
      </span>
    </div>
    {hint && <p className="text-xs ui-muted">{hint}</p>}
  </div>
);

export default VolumeSlider;
